export class Guid {

    private value: string = this.empty;
    private emptyValue: boolean;

    public get isEmpty() {
        return this.emptyValue;
    }

    public static get empty(): string {
        return '00000000-0000-0000-0000-000000000000';
    }

    public static parse(str: string) {
        const guid = new Guid();
        guid.setValue(str);
        return guid;
    }

    public setValue(str: string) {
        if (this.isValid(str)) {
            this.value = str;
        } else {
            this.value = this.empty;
            this.emptyValue = true;
        }

    }

    public get empty(): string {
        return Guid.empty;
    }

    constructor(obj?: any) {
        if (!obj)
            this.value = this.generate();
        else {
            this.value = obj;
            //Object.assign(this, obj)
        }

        this.emptyValue = false;
    }

    public isValid(str: string = ""): boolean {
        if (!str || str.length === 0) {
            return false;
        }
        const validRegex = /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i;
        return validRegex.test(str);
    }

    private generate(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    public toString() {
        return this.value;
    }

    public toJSON(): string {
        return this.value;
    }

    public equals(compare: Guid) {
        if (!compare) {
            return false;
        }
        return compare.toString() === this.toString();
    }
}
